  import { BrowserRouter, Routes, Route } from "react-router-dom";
  import { lazy, Suspense } from "react";

 const Home = lazy(() => import("./pages/Home"));
 const Products = lazy(() => import("./pages/Products"));
 const Services = lazy(() => import("./pages/Services"));
 const AboutUs = lazy(() => import("./pages/AboutUs"));
 const Contact = lazy(() => import("./pages/Contact"));
 const NoPage = lazy(() => import("./pages/NoPage"));
 const CableTray = lazy(() => import("./pages/CableTray"));
 const MetalDoor = lazy(() => import("./pages/MetalDoor"));
 const MetalEnclosure = lazy(() => import("./pages/MetalEnclosure"));
 const DixonShelf = lazy(() => import("./pages/DixonShelf"));
 const MetalProfiles = lazy(() => import("./pages/MetalProfiles"));
 const CNCBending = lazy(() => import("./pages/CNCBending"));
 const CNCPunching = lazy(() => import("./pages/CNCPunching"));
 const OmegaProfiles = lazy(() => import("./pages/OmegaProfiles"));
 const BreakerBox = lazy(() => import("./pages/BreakerBox"));
 const SheetMetalProducts = lazy(() => import("./pages/SheetMetalProducts"));
 const CNCShearing = lazy(() => import("./pages/CNCShearing"));
 const EngineeringDesign = lazy(() => import("./pages/EngineeringDesign"));
 const MetalWelding = lazy(() => import("./pages/MetalWelding"));
 const Machining = lazy(() => import("./pages/Machining"));

export default function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          fontSize: '18px',
          color: '#666'
        }}>
          Loading NAHMA Website...
        </div>
      }>
        <Routes>
           <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/cable-tray" element={<CableTray />} />
            <Route path="/products/metal-door" element={<MetalDoor />} />
            <Route path="/products/metal-enclosure" element={<MetalEnclosure />} />
            <Route path="/products/dixon-shelf" element={<DixonShelf />} />
            <Route path="/products/metal-profiles" element={<MetalProfiles />} />
            <Route path="/products/omega-profiles" element={<OmegaProfiles />} />
            <Route path="/products/breaker-box" element={<BreakerBox />} />
            <Route path="/products/sheet-metal-products" element={<SheetMetalProducts />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/cnc-bending" element={<CNCBending />} />
            <Route path="/services/cnc-punching" element={<CNCPunching />} />
            <Route path="/services/cnc-shearing" element={<CNCShearing />} />
            <Route path="/services/engineering-design" element={<EngineeringDesign />} />
            <Route path="/services/metal-welding" element={<MetalWelding />} />
            <Route path="/services/machining" element={<Machining />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NoPage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}